import { render, staticRenderFns } from "./initGruppiMail.vue?vue&type=template&id=4c704c0b&"
import script from "./initGruppiMail.vue?vue&type=script&lang=js&"
export * from "./initGruppiMail.vue?vue&type=script&lang=js&"
import style0 from "./initGruppiMail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
